import React from 'react';
import { ReactNotifications, Store } from 'react-notifications-component'
import { withRouter } from 'react-router-dom'
import 'react-notifications-component/dist/theme.css'
import { useSelector } from 'react-redux'
import socket from './Socket';

const { useState, useEffect, useRef } = React;

const Notificaciones = () => {
    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0].id
    
    const mostrarNotificacion = (data) => {
        Store.addNotification({
            title: data.title,
            message: `${data.mensaje.mensaje} ${data.estatusSolicitud}`,
            type: data.type,
            container: 'top-right',
            insert: 'top',
            animationIn: ['animate__animated animate__flipInY'],
            animationOut: ['animate__animated animate__flipOutY'],
            dismiss: {
                showIcon: true,
            }
        })
    }
    useEffect(() => {
        socket.on('mensajeParaBeneficiario', (mensaje) => {
            let title = null
            let type = null
            let estatusSolicitud = null
            switch (mensaje.data.estatus) {
                case 3:
                    title = 'Solicitud en revisión'
                    type = 'info'
                    estatusSolicitud = ' está en Revisión'
                    break;
                case 4:
                    title = 'Solicitud aceptada'
                    type = 'success'
                    mensaje.tipoSolicitud === 'FC_01' ? estatusSolicitud = ' fue aceptada. Favor de iniciar sesión nuevamente.' : estatusSolicitud = ' fue aceptada.'
                    break;
                case 5:
                    title = 'Solicitud denegada'
                    type = 'danger'
                    estatusSolicitud = ' fue denegada'
                    break;
                case 'default':
                    break
            }
            
            if (mensaje.data.idlogin === idUsuario || mensaje.idLogin === idUsuario) {
                const data = {
                    title,
                    mensaje,
                    type,
                    estatusSolicitud
                }
                mostrarNotificacion(data)
            }
        })
        socket.on('mensajeParaAtencionACliente', (mensaje) => {
            let title = null
            switch (mensaje.estatus) {
                case 2:
                    title = 'Recibio una nueva solicitud'
                    break;
                case 6:
                    title = 'Recibio una solicitud corregida'
                    break;
                case 'default':
                    break
            }
            if (usuario.tipoUsuario === 3) {
                const data = {
                    title: title,
                    mensaje,
                    type: 'info',
                    estatusSolicitud : ''
                }
                mostrarNotificacion(data)
            }
        })
    }, [socket])

    return (
        <div>
            <ReactNotifications />
        </div>
    )
};

export default withRouter(Notificaciones)
